/**
 * Props for the CallBackIconWithBgColor component.
 */
interface CallBackIconWithBgColorProps {
  /** Background fill color for the icon container. @default "#FAE6E6" */
  fillColor?: string;
  /** Stroke color for the callback/chat icon. @default "#CD0202" */
  strokeColor?: string;
  /** Width of the SVG element. @default "22" */
  width?: string;
  /** Height of the SVG element. @default "22" */
  height?: string;
}

/**
 * A callback/chat bubble icon with a customizable colored background.
 * Renders an SVG icon representing a message or callback notification.
 *
 * @param props - The component props
 * @returns A styled SVG callback icon with rounded background
 *
 * @example
 * ```tsx
 * // Default styling (light red background with red icon)
 * <CallBackIconWithBgColor />
 *
 * // Custom colors
 * <CallBackIconWithBgColor
 *   fillColor="#E6F0FA"
 *   strokeColor="#0066CC"
 *   width="24"
 *   height="24"
 * />
 * ```
 */
const CallBackIconWithBgColor = (props: CallBackIconWithBgColorProps) => {
  return (
    <svg
      width={props.width ?? "22"}
      height={props.height ?? "22"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="4" fill={props.fillColor ?? "#FAE6E6"} />
      <path
        d="M7.18056 8.32639H11M7.18056 11H13.2917M7.18056 15.5833V17.3674C7.18056 17.7744 7.18056 17.978 7.26399 18.0825C7.33656 18.1734 7.44659 18.2263 7.56291 18.2262C7.69666 18.226 7.85558 18.0989 8.17343 17.8446L9.99565 16.3868C10.3679 16.089 10.554 15.9401 10.7613 15.8342C10.9452 15.7403 11.1409 15.6716 11.3432 15.6301C11.5711 15.5833 11.8095 15.5833 12.2862 15.5833H14.2083C15.4918 15.5833 16.1335 15.5833 16.6237 15.3336C17.0549 15.1138 17.4055 14.7633 17.6252 14.3321C17.875 13.8418 17.875 13.2001 17.875 11.9167V7.79167C17.875 6.50821 17.875 5.86649 17.6252 5.37627C17.4055 4.94507 17.0549 4.59449 16.6237 4.37478C16.1335 4.125 15.4918 4.125 14.2083 4.125H7.79167C6.50821 4.125 5.86649 4.125 5.37627 4.37478C4.94507 4.59449 4.59449 4.94507 4.37478 5.37627C4.125 5.86649 4.125 6.50821 4.125 7.79167V12.5278C4.125 13.2382 4.125 13.5934 4.20309 13.8848C4.41499 14.6756 5.0327 15.2933 5.82354 15.5052C6.11496 15.5833 6.47016 15.5833 7.18056 15.5833Z"
        stroke={props.strokeColor ?? "#CD0202"}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CallBackIconWithBgColor;
